import { useCallback, useEffect, useMemo } from 'react'
import { useAddActionLogMutation } from '../api/v2/actionLogs'
import { useMyContext } from '../context/context'

const useActionLog = params => {
  const { myContext } = useMyContext()

  const [add] = useAddActionLogMutation()

  const addLog = useCallback(
    ({ actionId, userId, companyId, extended }) => {
      if (myContext) {
        add({ ...myContext, actionId, userId: userId || myContext.userId, companyId, extended })
      }
    },
    [add, myContext]
  )

  const { actionId, userId, companyId, extended } = params || {}

  const depsKey = useMemo(() => JSON.stringify({ actionId, userId, companyId, extended }), [actionId, userId, companyId, extended])

  useEffect(() => {
    if (actionId) {
      addLog({ actionId, userId, companyId, extended })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addLog, depsKey])

  return { addLog }
}

export default useActionLog
